import axios from "axios";

const filterElements = [...document.querySelectorAll('.js-filters')];

filterElements.map(filters => {
    let filtersTriggers;
    let filtersFilters;
    let filtersReset;
    let currentFiltersHtmlResponse = null;
    let currentFiltersUrl = null;

    const collection = document.querySelector('.js-collection');
    const priceFilterButton = document.querySelector('.js-filters-price-filter-button');

    const filtersChangeHandler = async e => {
        e.preventDefault();

        const popupContent = document.querySelector('.js-popup-content');
        const formData = new FormData(filters);
        const filteredParams = Array.from(formData.entries()).filter(([key, value]) => value !== '');
        const params = new URLSearchParams(filteredParams);

        const URLparams = new URLSearchParams(window.location.search);

        // Convert to arrays of entries
        const entries1 = Array.from(params.entries());
        const entries2 = Array.from(URLparams.entries());

        // Combine entries into a single array
        const allEntries = [...entries1, ...entries2];

        // Use a Set to filter out duplicates
        const uniqueEntries = Array.from(new Set(allEntries.map(entry => JSON.stringify(entry))))
            .map(entry => JSON.parse(entry));

        // Convert back to URLSearchParams if needed
        const uniqueParams = new URLSearchParams(uniqueEntries);

        popupContent.classList.add('loading');
        filters.classList.add('loading');
        currentFiltersUrl = `${filters.getAttribute('action')}${uniqueParams.toString().length > 0 ? '?' : ''}${uniqueParams.toString()}`;

        let response = await axios.get(currentFiltersUrl);

        if(response.status === 200) {
            updateFilters(response.data);
            updateUrl();
            popupContent.classList.remove('loading');
            filters.classList.remove('loading');
        }
    };

    const filtersResetHandler = async () => {
        currentFiltersUrl = filters.getAttribute('action');
        let response = await axios.get(currentFiltersUrl);

        if(response.status === 200) {
            updateFilters(response.data);
            updateUrl();
        }
    }

    const updateFilters = (data) => {
        const parser = new DOMParser();
        currentFiltersHtmlResponse = parser.parseFromString(data, 'text/html');
        filters.innerHTML = currentFiltersHtmlResponse.querySelector('.js-filters').innerHTML;

        initFilters();
        updateProducts();
    };

    const updateProducts = () => {
        if(currentFiltersHtmlResponse !== null) {
            collection.setAttribute('data-loading', '');

            setTimeout(() => {
                const collectionProductsCounts = [...collection.querySelectorAll('.js-collection-products-count')];
                const collectionProductsGrids = [...collection.querySelectorAll('.js-collection-products-grid')];


                collectionProductsCounts.map(collectionProductsCount => {
                    collectionProductsCount.innerHTML = currentFiltersHtmlResponse.querySelector('.js-collection-products-count').innerHTML;
                })

                collectionProductsGrids.map(collectionProductsGrid => {
                    collectionProductsGrid.innerHTML = currentFiltersHtmlResponse.querySelector('.js-collection-products-grid').innerHTML;
                })


                setTimeout(() => {
                    collection.removeAttribute('data-loading');
                }, 200);
            }, 200);
        }
    };

    const updateUrl = () => {
        if(currentFiltersUrl !== null) {
            window.history.pushState({}, '', currentFiltersUrl);
        }
    };

    const initFilters = () => {
        filtersTriggers = [...document.querySelectorAll('.js-filters-trigger')];
        filtersFilters = filters.querySelector('.js-filters-inner');
        filtersReset = filters.querySelector('.js-filters-reset');

        if(filtersReset) {
            filtersReset.addEventListener('click', filtersResetHandler);
        }

        const priceFilter = document.querySelector('.js-filters-price');

        if(priceFilter) {
            const minInput = priceFilter.querySelector('.js-filters-price-min-input');
            const maxInput = priceFilter.querySelector('.js-filters-price-max-input');
            const range = priceFilter.querySelector('.js-filters-price-range');
            const minRange = priceFilter.querySelector('.js-filters-price-min-range');
            const maxRange = priceFilter.querySelector('.js-filters-price-max-range');
            let min = +minInput.value;
            let max = +maxInput.value;
            const calculatePriceRange = () => {
                const left = 100 / (+maxRange.max - +minRange.min) * (min - +minRange.min);
                const right = Math.abs(100 / (+maxRange.max - +minRange.min) * (max - +maxRange.max));
                range.style.setProperty('left', `${left}%`);
                range.style.setProperty('right', `${right}%`);
            }
            const priceChangeHandler = e => {
                const currentInput = e.currentTarget;
                const {type} = currentInput.dataset;
                let newMin = +(type === 'min' ? currentInput.value || min : min);
                let newMax = +(type === 'max' ? currentInput.value || max : max);

                if(type === 'min' && newMin >= newMax) {
                    newMin = newMax - 1;
                } else if(type === 'max' && newMax <= newMin) {
                    newMax = newMin + 1;
                }
                if(newMin < minRange.min) {
                    newMin = minRange.min;
                }
                if(newMax > maxRange.max) {
                    newMax = maxRange.max;
                }
                min = newMin;
                max = newMax;
                minInput.value = min;
                maxInput.value = max;
                minRange.value = min;
                maxRange.value = max;
                minInput.setAttribute('max', max);
                maxInput.setAttribute('min', min);
                calculatePriceRange();
            }
            calculatePriceRange();

            [minInput, maxInput].map(input => input.addEventListener('change', priceChangeHandler));
            [minRange, maxRange].map(input => input.addEventListener('input', priceChangeHandler));
        }
    }

    initFilters();
    filters.addEventListener('change', filtersChangeHandler);

    if (priceFilterButton) {
        priceFilterButton.addEventListener('click', filtersChangeHandler);
    }
});

